import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { getClientName } from '@/helpers/clients';
import { useSelectServerDataManager, SingleSelect } from '@ui-kit/inputs/select';
import { ClientResource } from '@shared/resources/client';
import ClientBadge from '../ClientBadge.vue';

interface Props {
  modelValue?: ClientResource;
  dropdownHeight?: number;
  hideEmpty?: boolean;
  errors?: string|string[];
  searchPlaceholder?: string;
  selectOptionText?: string;
  deselectOptionText?: string;
  noOptionsText?: string,
  disabled?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientSelect',
  props: {
    modelValue: null,
    dropdownHeight: null,
    hideEmpty: { type: Boolean },
    errors: null,
    searchPlaceholder: null,
    selectOptionText: null,
    deselectOptionText: null,
    noOptionsText: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  modelValue?: ClientResource;
  dropdownHeight?: number;
  hideEmpty?: boolean;
  errors?: string|string[];
  searchPlaceholder?: string;
  selectOptionText?: string;
  deselectOptionText?: string;
  noOptionsText?: string,
  disabled?: boolean;
}



const clientsSelectManager = useSelectServerDataManager({
  path: 'clients/grid',
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SingleSelect), {
    "data-manager": _unref(clientsSelectManager),
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    "select-option-text": __props.selectOptionText || _ctx.$t('pages.common.select-client'),
    "search-placeholder": __props.searchPlaceholder,
    "hide-empty": __props.hideEmpty,
    "no-options-text": __props.noOptionsText,
    "dropdown-height": __props.dropdownHeight,
    "deselect-option-text": __props.deselectOptionText,
    disabled: __props.disabled,
    errors: __props.errors
  }, {
    "selected-option": _withCtx(({ value }) => [
      _createVNode(ClientBadge, {
        class: "mr-2",
        type: value.type
      }, null, 8, ["type"]),
      _createTextVNode(" " + _toDisplayString(_unref(getClientName)(value)), 1)
    ]),
    option: _withCtx(({ option }) => [
      _createVNode(ClientBadge, {
        class: "mr-2",
        type: option.type
      }, null, 8, ["type"]),
      _createTextVNode(" " + _toDisplayString(_unref(getClientName)(option)), 1)
    ]),
    _: 1
  }, 8, ["data-manager", "model-value", "select-option-text", "search-placeholder", "hide-empty", "no-options-text", "dropdown-height", "deselect-option-text", "disabled", "errors"]))
}
}

})